module.exports = __webpack_public_path__ + "static/media/coveragegif5.e85b3721.gif";